<template>
  <div>
    <div v-for="(product, index) in products" :key="index">
      <div class="mainBox" v-for="i in copyCount" :key="i">
        <div class="Box-1">
          <div class="partition-1">
            <p>
              <b>Business Name : {{ (parentUser && parentUser.business_name) || (parentUser && parentUser.username) }} </b>
            </p>
            <p>
              <b>License # : {{ parentUser && parentUser.omma_license_number }} </b>
            </p>
            <p>
              <b>Phone # : {{ parentUser && parentUser.mobile }} </b>
            </p>
            <p>
              <b>Product Name : {{ product.product_name }}</b>
            </p>
            <p>
              <b>Batch # : {{ product.batchNumber }}</b>
            </p>
            <p>
              <b>Quantity : {{ product.quantity | weightFilter }}</b>
            </p>
            <p>
              <b>Weight Type : {{ product.weight_type }}</b>
            </p>
            <p>
              <b>THC : {{ product.thc }} </b>
            </p>
            <p>
              <b>CBD : {{ product.cbd }} </b>
            </p>
            <p>
              <b>Terpenoid Potency : {{ product.terpenoid_potency }} </b>
            </p>
          </div>
          <div class="partition-2">
            Caution:Women should not use marijuana or medical marijuana during pregnancy because of the risk of health defects or while breastfeeding. Keep out of reach of children. For accidental
            ingestion call 1-800-222-1222. This product has been tested for contaminants.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { weightMixins } from '@/utils/weightType'

export default {
  name: 'PrintExitLabel',
  props: {
    products: {
      type: Array
    },
    sale: {
      type: Object
    },
    copy: {
      default: 1
    }
  },
  mixins: [weightMixins],

  computed: {
    ...mapState('auth', ['parentUser']),
    copyCount() {
      return Array(Number(this.copy)).fill(null)
    }
  },
  mounted() {},

  // filters
  filters: {
    //weightFilter rounded conversation
    weightFilter(value) {
      return weightMixins.methods.mathRound(Number(value), 3)
    }
  }
}
</script>

<style lang="scss">
body {
  // height: 99%;
}

.mainBox {
  height: 3.125in;
  width: 11.5in;
  /* border: 1px solid black; */
  font-weight: bolder;
  color: #000;
  padding: 5px;
  // margin-top: 30px;
  font-size: 20px;
  // transform: rotate(90deg);
  // transform-origin: 13% 70%;
  page-break-after: always;
}

.Box-1 {
  display: flex;
}

.partition-1 {
  white-space: nowrap;
}

.partition-2 {
  padding: 0px 0px 13px 60px;
  white-space: wrap;
  font-weight: bold;
}

.subBox {
  border: 1px solid black;
  padding: 15px;
}

@media print {
  body {
    height: 50%;
  }

  .mainBox {
    height: 3.125in;
    width: 11.5in;
    /* border: 1px solid black; */
    font-weight: bolder;
    color: #000;
    padding: 5px;
    margin-top: 30px;
    font-size: 20px;
    transform: rotate(90deg);
    transform-origin: 13% 70%;
    page-break-after: always;
  }

  .Box-1 {
    display: flex;
  }

  .partition-1 {
    white-space: nowrap;
  }

  .partition-2 {
    padding: 0px 0px 13px 60px;
    white-space: wrap;
    font-weight: bold;
  }

  .subBox {
    border: 1px solid black;
    padding: 15px;
  }
}
</style>
